<template>
  <div
    style="height:100%; width:100%; position: absolute; top:0px; display: flex;flex-direction:column;"
    :style="cssProps"
  >
    <div class="topBar">
      <div class="topBarTitle">
        Gruba katılımcı ekle
      </div>
    </div>
    <div class="groupParticipants">
      <div
        class="groupParticipant"
        v-for="participant in $store.state.group.addToGroup.participants"
        :key="participant.UserID + 'ngp'"
      >
        <img
          class="participantPhoto"
          :src="participant.PhotoURL"
          v-if="participant.PhotoURL"
        >
        <img
          class="participantPhoto"
          src="@/assets/images/nophoto.png"
          v-if="!participant.PhotoURL"
        >
        <div>{{ participant.VisibleName }}</div>
        <img
          class="removeParticipant"
          src="@/assets/images/close3.png"
          @click="removeParticipant(participant)"
        >
      </div>
    </div>
    <div class="searchBar">
      <input @keyup="changeSearchKeyWithTimer($event.target.value)" placeholder="Kişilerde ara">
    </div>
    <div class="contactListContainer">
      <div v-for="letter in letters" :key="letter + 'KK'">
        <div class="letterHeader" v-if="getLetterFilteredContacts(letter).length > 0">
          {{ letter }}
        </div>
        <ContactRow
          v-for="contact in getLetterFilteredContacts(letter)"
          :key="contact.UserID"
          :contact="contact"
          @click.native="appendAdditionalGroupParticipant(contact)"
          v-waypoint="waypointOptions"
          :data-photourl="contact.PhotoURL"
          :data-visiblename="contact.VisibleName"
        />
      </div>
    </div>

    <div
      class="proceedNextPage"
      :class="{
        proceedNextPageVisible:
          $store.state.group.addToGroup.participants.length > 0
      }"
    >
      <div @click="addParticipants">
        <img src="@/assets/images/right-arrow.png">
      </div>
    </div>
  </div>
</template>

<script>
import ContactRow from '@/components/home/leftcolumn/newConversation/ContactRow.vue'
import {
  socketOutputMixin
} from '@/mixins/socketOutputMixin.js'

export default {
  mixins: [socketOutputMixin],
  data () {
    return {
      searchKey: '',
      searchKeyTemp: '',
      searchDelay: 0,
      waypointOptions: {
        active: true,
        callback: this.onWaypoint,
        options: {
          root: null,
          rootMargin: '0px 0px 0px 0px',
          threshold: [0, 1]
        }
      }
    }
  },
  methods: {
    onWaypoint (waypoint) {
      if (waypoint.going === 'in' && !waypoint.el.classList.contains('loaded')) {
        let photourl = waypoint.el.dataset.photourl
        if (!photourl || photourl === '') {
          photourl = '/images/nophoto.png'
        }
        waypoint.el.children[0].src = photourl

        let visiblename = waypoint.el.dataset.visiblename
        waypoint.el.children[1].innerHTML = visiblename

        waypoint.el.classList.add('loaded')
      }
    },

    changeSearchKeyWithTimer (searchKey) {
      var vm = this
      if (searchKey !== vm.searchKeyTemp) {
        vm.searchKeyTemp = searchKey
        vm.searchDelay = 3
        vm.changeSearchKeyWithTimer(searchKey)
      } else {
        vm.searchDelay--
        vm.searchDelay = vm.searchDelay < 0 ? 0 : vm.searchDelay
        if (vm.searchDelay > 0) {
          setTimeout(function () {
            if (searchKey === vm.searchKeyTemp) {
              vm.changeSearchKeyWithTimer(vm.searchKeyTemp)
            }
          }, 1000)
        } else {
          vm.searchKey = searchKey
        }
      }
    },

    getLetterFilteredContacts (letter) {
      let additionalParticipantIDs = this.$store.state.group.addToGroup.participants.map(
        p => p.UserID
      )
      additionalParticipantIDs = additionalParticipantIDs.concat(this.$store.state.group.addToGroup.oldParticipants)

      return this.$store.getters.filteredContacts
        .filter(
          contact =>
            contact.VisibleName && contact.VisibleName.charAt(0).toLocaleUpperCase('tr') === letter
        )
        .filter(contact => {
          if (this.searchKey === '') {
            return contact
          }
          return contact.VisibleName.toLocaleLowerCase('tr').includes(
            this.searchKey.toLocaleLowerCase('tr')
          )
            ? contact
            : null
        })
        .filter(contact => {
          return additionalParticipantIDs.includes(contact.UserID)
            ? null
            : contact
        })
    },

    appendAdditionalGroupParticipant (participant) {
      this.$store.commit('appendAdditionalGroupParticipant', participant)
    },

    removeParticipant (participant) {
      let newArray = this.$store.state.group.addToGroup.participants.filter(
        p => p.UserID !== participant.UserID
      )
      this.$store.commit('setAdditionalGroupParticipants', newArray)
    },

    closeModal () {
      this.$modal.hide('homepage')
    },

    addParticipants () {
      let Participants = this.$store.state.group.addToGroup.participants.map(participant => participant.UserID)
      let GroupID = this.$store.state.conversation.activeConversation.GroupID

      this.sendAddToGroupMessage(GroupID, Participants)
      this.$modal.hide('homepage')
    }
  },

  computed: {
    cssProps () {
      return {
        '--topBarColor': this.$config.theme.default.sideMenu.topBarColor,
        '--fontColor': this.$config.theme.default.sideMenu.fontColor,
        '--buttonColor': this.$config.theme.default.sideMenu.buttonColor
      }
    },
    letters () {
      let a = 'ABCÇDEFGHIİJKLMNOÖPRSŞTUÜVYZ'.split('')
      return a
    }
  },

  components: {
    ContactRow
  }
}
</script>

<style scoped>
.topBar {
  background-color: var(--topBarColor);
  height: 60px;
  display: flex;
  align-items: flex-end;
  flex-grow: 0;
  flex-shrink: 0;
}

.topBarTitle {
  color: white;
  font-size: 16px;
  font-weight: 700;
  margin: 10px;
  line-height: 40px;
}

.closeColumnBtn {
  cursor: pointer;
}

.closeColumnBtn > img {
  width: 30px;
  height: 30px;
  margin: 10px;
  margin-left: 20px;
}

.contactListContainer {
  background-color: #eaeceb;
  width: 100%;
  flex-grow: 1;
  overflow: scroll;
  overflow-x: hidden;
}

.letterHeader {
  color: var(--fontColor);
  padding: 10px;
  font-weight: 700;
  background-color: #eaeceb;
}

.searchBar {
  padding: 5px;
  background-color: #eaeceb;
  border-bottom: 1px solid rgb(209, 209, 209);
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
}

.searchBar > input {
  border: none;
  flex-grow: 1;
  border-radius: 30px;
  padding: 15px 30px;
}

.searchBar > input:focus {
  outline: none;
}

.searchBarLeftIcon {
  background-color: white;
  width: 30px;
  height: 30px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}

.searchBarRightIcon {
  background-color: white;
  width: 30px;
  height: 30px;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
}

.groupParticipants {
  background-color: white;
  display: flex;
  flex-wrap: wrap;

  flex-grow: 0;
  flex-shrink: 0;
}

.groupParticipant {
  background-color: rgb(240, 239, 239);
  padding-left: 0px;
  padding-right: 1px;
  font-size: 9px;
  font-weight: 700;
  margin: 2px;
  height: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
}

.participantPhoto {
  width: 20px;
  height: 20px;
  border-radius: 10px;
  margin-right: 5px;
}

.removeParticipant {
  width: 20px;
  height: 20px;
  border-radius: 10px;
  cursor: pointer;
}

.proceedNextPage {
  height: 0px;
  flex-shrink: 0;
  flex-grow: 0;
  display: flex;
  justify-content: center;
  transition: height 0.25s ease;
}

.proceedNextPageVisible {
  height: 50px !important;
  padding: 20px;
}

.proceedNextPage > div {
  background-color: var(--buttonColor);
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  border-radius: 25px;
  justify-content: center;
  cursor: pointer;
}

.proceedNextPage > div > img {
  width: 20px;
  height: 20px;
}
</style>
